module.exports = __webpack_public_path__ + "static/img/001.27f4a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/awards/001.png
// module id = J0Sp
// module chunks = 0